<template>
  <div id="container"></div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { decryptionECB } from '@/utils/utils.js'
const store = useStore()

const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
onMounted(() => {
  // var map = new BMapGL.Map('container')
  // const pointlng = 116.12738
  // const pointlat = 40.09246
  // map.centerAndZoom(new BMapGL.Point(pointlng, pointlat), 18)
  // map.enableScrollWheelZoom(true)
  // // 创建点标记
  // var marker1 = new BMapGL.Marker(new BMapGL.Point(pointlng, pointlat))
  // // 在地图上添加点标记
  // map.addOverlay(marker1)
  // marker1.addEventListener('click', function () {
  //   map.openInfoWindow(infoWindow, point)
  // })

  // var point = new BMapGL.Point(pointlng, pointlat)
  // var opts = {
  //   width: 300,
  //   height: 120,
  //   title: ''
  // }
  // const content =
  //   '<h3>北京五矿君澜酒店' +
  //   '<a target="_blank" style="font-size: 14px; color: blue; margin-left:15px;" id="jump" href="https://map.baidu.com/mobile/webapp/search/search/qt=s&wd=%E5%8C%97%E4%BA%AC%E4%BA%94%E7%9F%BF%E5%90%9B%E6%BE%9C%E9%85%92%E5%BA%97&c=131&searchFlag=bigBox&version=5&exptype=dep&src_from=webapp_all_bigbox&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA&sug_forward=ece2a4f0ab3d11e414a1902e&src=1&nb_x=12937653.66&nb_y=4808390.4&center_rank=1/vt=/?fromhash=1#search/search/qt=s&wd=%E5%8C%97%E4%BA%AC%E4%BA%94%E7%9F%BF%E5%90%9B%E6%BE%9C%E9%85%92%E5%BA%97&c=131&searchFlag=bigBox&version=5&exptype=dep&src_from=webapp_all_bigbox&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA&sug_forward=ece2a4f0ab3d11e414a1902e&src=1&nb_x=12937653.66&nb_y=4808390.4&center_rank=1/vt=map">详情>></a>' +
  //   '</h3>' +
  //   '<p>地址：北京市海淀区北安河路55号院1号楼</p>'
  // var infoWindow = new BMapGL.InfoWindow(content, opts)
  // map.openInfoWindow(infoWindow, point)

  // infoWindow.addEventListener('open', function () {
  //   setTimeout(() => {
  //     console.log(document.getElementById('jump'))
  //   }, 1000)
  // })
  // 百度地图API功能
  // var map = new BMap.Map('container') // 创建Map实例
  // // map.addControl(new BMap.MapTypeControl()) //添加地图类型控件
  // const addr = '北京五矿君澜酒店'
  // map.centerAndZoom(addr, 18) // 初始化地图,用城市名设置地图中心点
  // var local = new BMap.LocalSearch(map, {
  //   renderOptions: { map: map, panel: 'r-result' }
  // })
  // local.search(addr)

  var map = new BMap.Map('container')
  map.centerAndZoom(gconfig.value.ExhibitionAddress, 18)
  map.enableScrollWheelZoom(true)
  var local = new BMap.LocalSearch(map, {
    renderOptions: { map: map }
  })
  local.search(gconfig.value.ExhibitionAddress)
})
</script>
<style lang="less">
body,
html,
#container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: '微软雅黑';
}
</style>
